import { useLocation, useNavigate } from "react-router-dom";
import { useIdleTimer } from 'react-idle-timer'
import { useSelector } from "react-redux";
import { selectIsLoggedIn } from "../../services/authorization/slices";
import { ROUTE_KEYS, ROUTES } from "../../_configuration/routing/constants";

const TIMEOUT = 60000 * (parseInt(process.env.REACT_APP_TIMEOUT) || 120);
const logoutPath = ROUTES[ROUTE_KEYS.LOGOUT].path

function useLogOutOnIdle() {
  const navigate = useNavigate();
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const { pathname } = useLocation()

  const handleOnIdle = (event) => {
    console.log("user is idle", event);
    console.log("last active", getLastActiveTime());
    const redirectToLogout = isLoggedIn && (pathname !== logoutPath)
    redirectToLogout && navigate(logoutPath);
  };
  const { getLastActiveTime } = useIdleTimer({
    timeout: TIMEOUT,
    onIdle: handleOnIdle
  });
}
export default useLogOutOnIdle;
